module.exports = __webpack_public_path__ + "media/images/service/ball-bbe94287a08ae561f3fd132b7d9b54a6.png";